"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/HeartFull.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var HeartFull = function HeartFull(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 220.17 195.55"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Heart Icon"), _react2.default.createElement("path", {
    className: "heart-full",
    d: "M216.32 59.4C213.21 27 189 3.5 158.63 3.5a58 58 0 0 0-49.13 26.78 55.86 55.86 0 0 0-48-26.78C31.21 3.5 7 27 3.86 59.39c-.25 1.43-1.25 9 1.81 21.24 4.42 17.71 14.63 33.87 29.51 46.58L109.45 191 185 127.21c14.89-12.71 25.1-28.86 29.51-46.58 3.06-12.28 2.05-19.81 1.81-21.23z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = HeartFull;